import { RootState } from "@/store";

export const selectStringParam = (_state: RootState, value: string) => value;

export const selectNumberParam = (_state: RootState, value: number) => value;

export const selectOptionalStringParam = (_state: RootState, value?: string) =>
    value;

export const selectParams = <P>(_state: RootState, params: P): P => params;
